export default __webpack_public_path__ + "static/media/sticker-H.02592e58.png";